import { Link as RouterLink, type LinkProps } from "react-router-dom";
import { useLanguage } from "@/hooks/useLanguage";
import { currentHost, resolveSiteLink } from "@/lib/site/hosts";

/**
 * A link on the public pages, written the old way (`to="/privacy"`,
 * `to="/auth"`) and resolved for the host: the page's slug on zettl.cz
 * (`/ochrana-osobnich-udaju`), and app paths on app.zettl.cz when the page is
 * on zettl.cz. Absolute URLs leave the SPA.
 */
export function SiteLink({ to, ...props }: Omit<LinkProps, "to"> & { to: string }) {
  const { language } = useLanguage();
  return <RouterLink to={resolveSiteLink(to, language, currentHost())} {...props} />;
}
